import React, {
    Component,
    PureComponent
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'
import { actionTypes } from '../constants';
import moment from 'moment';

import fetch from '../utils/fetch';
import awsconfig from '../awsconfig';

import Icon from '@material-ui/core/Icon';

import EnhancedTable from '../widgets/table-enhanced'
import LinkButton from '../widgets/button-link'
import ChipDetails from '../widgets/chip-details'
import InputClickEditable from '../widgets/input-click-editable'
import DropdownFilterMenu from '../widgets/dropdown-filter-menu';

import ButtonBase from "@material-ui/core/ButtonBase";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

export const ActionsMenu = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = event => {
        console.log('buttonbase onClick!')
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e) => {
        console.log('handleClose!');
        e.stopPropagation();
        setAnchorEl(null);
    };

    // console.log(props)

    return (
        <React.Fragment>
            <ButtonBase
                className="button button-clear"
                onClick={handleClick}
            >
                Actions
            </ButtonBase>
            <Menu
                anchorEl={anchorEl}
                key={props.report._id}
                open={Boolean(anchorEl)}
                keepMounted={true}
                className="report-actions"
                autoFocus={false}
                variant='selectedMenu'
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                disableScrollLock={true}
            >
                {!props.report.vcaClaimId ? (
                    <React.Fragment>
                        {!props.report.fromInternalOnlyClient ? '' : (
                            <MenuItem onClick={e=>{
                                handleClose(e);
                                props.history.push(`/app/reports/modal/assign-user/${props.report._id}`)
                            }}>
                                <ListItemIcon>
                                    <Icon>person_add</Icon>
                                </ListItemIcon>
                                <ListItemText
                                    inset={false}
                                    primary="Assign to User"
                                    secondary="Assign this Claim to a different Exmarx User"
                                />
                            </MenuItem>
                        )}
                        {!props.report.accidentNumber ? '' : (
                            <MenuItem onClick={e=>{
                                handleClose(e);
                                props.dispatch({type: actionTypes.REPORTS_SUBMIT_ONE_VCA, id: props.report._id})
                            }}>
                                <ListItemIcon>
                                    <Icon>publish</Icon>
                                </ListItemIcon>
                                <ListItemText
                                    inset={false}
                                    primary="Submit to VCA"
                                    secondary="Submit the Claim to Virtual Claims Adjuster"
                                />
                            </MenuItem>
                        )}
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        {!props.report.accidentNumber && props.photos.length > 0 ? '' : (
                            <MenuItem onClick={async e=>{
                                handleClose(e);
                                props.dispatch({type: actionTypes.SPINNING_START});
                                try {
                                    await fetch({
                                        url: `${awsconfig.officeApi}/reports/${props.report._id}/vca-photos`,
                                        data: {},
                                        method: 'post',
                                    })
                                    props.dispatch({
                                        type: actionTypes.SNACKBAR,
                                        snackbar: {
                                            severity: 'success',
                                            text: `The photos for report ${props.report.vcaClaimId} will attempt to sync.`
                                        }
                                    })
                                } catch (err) {
                                    props.dispatch({
                                        type: actionTypes.SNACKBAR,
                                        snackbar: {
                                            severity: 'error',
                                            text: err.message
                                        }
                                    });
                                }
                                props.dispatch({type: actionTypes.SPINNING_STOP});
                            }}>
                                <ListItemIcon>
                                    <Icon>publish</Icon>
                                </ListItemIcon>
                                <ListItemText
                                    inset={false}
                                    primary="Re-upload Photos to VCA"
                                    secondary="Send photo uploads to Virtual Claims Adjuster"
                                />
                            </MenuItem>
                        )}
                        <MenuItem onClick={e=>{
                            handleClose(e);
                            window.open(`https://citadel.virtualclaimsadjuster.com/claims/viewer/general.asp?PID=${props.report.vcaClaimId}`)
                        }}>
                            <ListItemIcon>
                                <Icon>launch</Icon>
                            </ListItemIcon>
                            <ListItemText
                                inset={false}
                                primary="Open in VCA"
                                secondary="View the Claim in Virtual Claims Adjuster"
                            />
                        </MenuItem>
                    </React.Fragment>
                )}
                <MenuItem onClick={e=>{
                    console.log(props)
                    handleClose(e);
                    props.history.push(`/app/reports/${props.report._id}/activity`)
                }}>
                    <ListItemIcon>
                        <Icon>pageview</Icon>
                    </ListItemIcon>
                    <ListItemText
                        inset={false}
                        primary="View Report"
                        secondary="View the Report details"
                    />
                </MenuItem>
            </Menu>
        </React.Fragment>
    )
}

export default ActionsMenu;